<template>
    <div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.orderNo"
                    placeholder="请输入工单号、执行人姓名"
                    :width="250"
                    style="margin-left: 10px;"
                    @search="search"
                ></table-searcher>
                <label style="margin-left: 20px">服务类别</label>
                <Select
                    v-model="filter.serviceType"
                    :class="preCls + 'select-public-style'"
                    transfer
                    clearable
                    @on-change="search"
                >
                    <Option
                        v-for="(item, index) in serviceTypeList"
                        :value="item.id"
                        :key="index"
                    >{{item.text}}</Option>
                </Select>
                <label>状态</label>
                <check-tag-group
                    style="display: inline-block;margin-left: 20px"
                    multiple
                    checkAll
                    v-model="orderStatus"
                    color="primary"
                >
                    <check-tag
                        v-for="item in orderStatusList"
                        :name="item.id"
                        :key="item.id"
                    >{{item.text}}</check-tag>
                </check-tag-group>
            </template>
        </table-tool-bar>
        <Table ref="mt" :columns="columns" :data="page.list" :loading="loading" :height="mtHeight">
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    v-if="row.orderStatus == 5"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickSummary(row)"
                >查看总结</Button>
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickInfo(row)"
                >详情</Button>
                <Button
                    v-if="$can('changeExec') && row.orderStatus != 5 && row.orderStatus != 7"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="rowClickChange(row)"
                >变更</Button>
                <PoptipButton
                    v-if="$can('delete')"
                    text="删除"
                    transfer
                    type="default"
                    title="确认删除该条记录?"
                    :ok="() => { rowConfirmDel(row) }"
                ></PoptipButton>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showInfo"
            :title="curId ? '工单详情' : '工单登记'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
            :buttons.sync="buttons"
        >
            <form-info v-if="modal.showInfo" :id="curId"></form-info>
        </smart-modal>
        <smart-modal
            v-model="modal.showSummary"
            title="查看总结"
            :width="800"
            :height="600"
            :maskClosable="false"
            :buttons.sync="buttons"
        >
            <form-summary v-if="modal.showSummary" :id="curId" :serviceType="rowServiceType"></form-summary>
        </smart-modal>
        <smart-modal
            v-model="modal.showExecute"
            title="更换执行人"
            :width="600"
            :height="310"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <form-execute v-if="modal.showExecute" :id="curId"></form-execute>
        </smart-modal>
    </div>
</template>         
<script>
import { mapCell, pipeCell } from '_c/grid/renderCell'
import FormInfo from '../form-order'
import FormSummary from '../form-summary'
import FormExecute from './form-execute'
import { orderList, orderDelete } from '@/api/order-manage'
import Dict from '_u/dict'

const PAGE_SIZE = 20

export default {
    name: 'ListOrderWait',

    components: {
        FormInfo,
        FormExecute,
        FormSummary
    },
    props: {
        date: Object
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                orderDataSource: 'G',
                orderNo: this.$cache.orderNo || '',
                serviceType: this.$cache.serviceType || '',
                orderStatus: this.$cache.orderStatusAlready || ''
            },
            // 已派工单
            alreadyStatus: ['3', '5', '6', '7'],
            page: {
                total: 0,
                list: []
            },
            dict: {
                orderStatus: Dict.NULL,
                busType: Dict.NULL,
                serviceType: Dict.NULL
            },
            modal: {
                showInfo: false,
                showExecute: false,
                showSummary: false
            },
            curId: '',
            rowServiceType: "",
            buttons: []
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'orderNo',
                    title: '工单号',
                    align: 'left',
                    minWidth: 180
                },
                {
                    key: 'customerName',
                    title: '客户名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'serviceType',
                    title: '服务类别',
                    align: 'center',
                    width: 100,
                    render: mapCell(this.dict.serviceType.val())
                },
                {
                    key: 'orderStatus',
                    title: '状态',
                    align: 'center',
                    width: 100,
                    render: mapCell(this.dict.orderStatus.val())
                },
                {
                    key: 'createUserName',
                    title: '报单人',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'createUserPhone',
                    title: '报单电话',
                    align: 'center',
                    minWidth: 120
                },
                {
                    key: 'contactName',
                    title: '联系人',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'contactPhone',
                    title: '联系电话',
                    align: 'left',
                    minWidth: 120
                },
                {
                    key: 'execUserName',
                    title: '执行人',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'execUserPhone',
                    title: '执行电话',
                    align: 'center',
                    minWidth: 120
                },
                {
                    key: 'createTime',
                    title: '报单时间',
                    align: 'center',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'planCompleteTime',
                    title: '要求完成时间',
                    align: 'center',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'addr',
                    title: '实施地址',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true
                },

                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed: 'right',
                    slot: 'action'
                }
            ]
        },

        orderStatusList() {
            return this.dict.orderStatus
                .val()
                .filter(el => this.alreadyStatus.includes(el.id))
        },

        orderStatus: {
            get() {
                return this.filter.orderStatus.split(',')
            },
            set(el) {
                this.filter.orderStatus = el.join(',')
                this.search()
            }
        },

        serviceTypeList() {
            return this.dict.serviceType.val()
        },

        serviceType: {
            get() {
                return this.filter.serviceType.split(',').filter(el => el)
            },
            set(el) {
                this.filter.serviceType = el.join(',')
            }
        }
    },

    watch: {
        'filter.orderStatus': function(val) {
            this.$cache.orderStatusAlready = val
        },
        'filter.serviceType': function(val) {
            this.$cache.serviceType = val
        },
        'filter.orderNo': function(val) {
            this.$cache.orderNo = val
        },
        date: {
            handler(val) {
                this.search()
            },
            deep: true
        }
    },

    created() {
        Promise.all([Dict.get(['order_status', 'bus_type', 'service_type'])])
            .then(args => {
                var [dictGroup, page] = args
                Object.keys(this.dict).forEach(name => {
                    this.dict[name] = dictGroup[name]
                })
            })
            .then(args => {
                this.fetch()
            })
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true
            let date = Object.assign({}, this.date),
                body = Object.assign(date, this.filter)
            if (!body.orderStatus) {
                body.orderStatus = this.alreadyStatus.join(',')
            }
            Promise.all([orderList(body)])
                .then(args => {
                    var [page] = args
                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            let list = data.page.list
            list.forEach(el => {
                el.cellClassName = {
                    orderStatus: `order-status-color${el.orderStatus || 999}`
                }
            })
            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },

        rowClickInfo(row) {
            this.curId = row.id
            this.modal.showInfo = true
        },

        rowClickSummary(row) {
            this.curId = row.id
            this.rowServiceType = row.serviceType
            this.modal.showSummary = true
        },

        rowClickChange(row) {
            this.curId = row.id
            this.modal.showExecute = true
        },

        rowConfirmDel(row) {
            this.loading = true
            orderDelete(row.id)
                .then(res => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>